import React, { useRef, lazy } from 'react';
// Define the flavor feature labels
const FeatureLabel = ({
  text,
  color
}: {
  text: string;
  color: string;
}) => <span className={`inline-block text-xs px-2 py-0.5 rounded-full ${color} mr-1 mb-1 whitespace-nowrap font-medium`} data-id="element-194">
    {text}
  </span>;
const flavorOptions = [{
  name: 'Watermelon Lime',
  hipsterName: 'Summer Citrus Fusion',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/6W6JgBhaUTenHiv6pXEJpD/Watermelon_Lime_%281%29.webp',
  color: 'bg-red-400',
  description: 'Refreshing watermelon sweetness perfectly balanced with zesty lime for a vibrant, thirst-quenching experience',
  features: ['Zero Calories', 'Alkaline', 'Vegan', 'Vitamin Infused', 'Flavored Water']
}, {
  name: 'Mango',
  hipsterName: 'Tropical Gold Nectar',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/oFf4rSt3d2KHvZ1rskh9CS/Mango.webp',
  color: 'bg-amber-400',
  description: 'Luscious, sun-ripened sweetness with exotic tropical notes',
  features: ['Zero Calories', 'Alkaline', 'Vegan', 'Vitamin Infused', 'Flavored Water']
}, {
  name: 'Cold Brew Coffee',
  hipsterName: 'Artisan Dark Roast Infusion',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/rwmmarcsQ5NWNYrrfydTyF/Cold_Brew_Coffee.webp',
  color: 'bg-amber-950',
  description: 'Smooth, rich cold-brewed coffee with subtle chocolate notes and a velvety finish',
  features: ['Organic', 'Alkaline', 'Coffee']
}, {
  name: 'Diet Cola',
  hipsterName: 'Classic Refresher',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/cfVdYWH3bUfpHLLkyUJ7n6/Diet_Cola.png',
  color: 'bg-amber-900',
  description: 'Classic cola flavor with zero calories for a guilt-free refreshment experience',
  features: ['Zero Calories', 'Alkaline', 'Vegan', 'Vitamin Infused', 'Soda']
}, {
  name: 'Iced Tea',
  hipsterName: 'Sun-Steeped Heritage Brew',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/gmRucDzmELpjfDMJ3whR9S/Iced_Tea.webp',
  color: 'bg-amber-500',
  description: "Classic sweetened iced tea with subtle citrus notes and a crisp, clean finish that's perfectly balanced",
  features: ['Organic Cane Sugar', 'Alkaline', 'Tea']
}, {
  name: 'Citrus Sport',
  hipsterName: 'Energizing Citrus Elixir',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/4rc785G36bYhNi2rSpwHpu/Citrus_Sport.webp',
  color: 'bg-yellow-300',
  description: 'Vibrant blend of zesty citrus with a refreshing finish, perfect for active lifestyles',
  features: ['Organic Cane Sugar', 'Alkaline', 'Vitamin Infused', 'Electrolytes', 'Soda']
}, {
  name: 'Lemon Lime',
  hipsterName: 'Citrus Duet Sparkle',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/nT14Txux4pqx7ThSPCZK7p/Lemon_Lime_.webp',
  color: 'bg-lime-300',
  description: 'Bright lemon and lime notes perfectly balanced for a crisp, refreshing experience',
  features: ['Zero Calories', 'Alkaline', 'Vegan', 'Vitamin Infused', 'Flavored Water']
}, {
  name: 'Peach Ginger',
  hipsterName: 'Stone Fruit Spice Infusion',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/cTgqWH21Y7JuHCKf6oqA2S/Peach_Ginger_%281%29.webp',
  color: 'bg-orange-300',
  description: 'Sweet peach notes with a warm, spicy ginger kick that awakens the senses',
  features: ['Zero Calories', 'Alkaline', 'Vegan', 'Vitamin Infused', 'Flavored Water']
}, {
  name: 'Pineapple Coconut',
  hipsterName: 'Tropical Island Blend',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/cMXm36mz7sEAh2E48aXowM/Pineapple_Coconut.webp',
  color: 'bg-yellow-100',
  description: 'Creamy coconut with bright pineapple accents for a refreshing island escape',
  features: ['Organic Cane Sugar', 'Alkaline', 'Vitamin Infused', 'Soda']
}, {
  name: 'Raspberry Blackberry',
  hipsterName: 'Berry Fusion Elixir',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/qfyRZmuTMZCUVxgfTULvg3/Raspberry_Blackberry.webp',
  color: 'bg-purple-600',
  description: 'Vibrant blend of tart raspberries and rich blackberries with a hint of citrus',
  features: ['Zero Calories', 'Alkaline', 'Vegan', 'Vitamin Infused', 'Flavored Water']
}, {
  name: 'Root Beer',
  hipsterName: 'Artisanal Sarsaparilla Brew',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/1XRMr4AZETZoF3FQoD7zmQ/Root_Beer.webp',
  color: 'bg-amber-800',
  description: 'Classic nostalgic flavor with a perfect balance of vanilla and spice notes',
  features: ['Organic Cane Sugar', 'Alkaline', 'Vitamin Infused', 'Soda']
}, {
  name: 'Tangerine',
  hipsterName: 'Citrus Sunset Splash',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/obrEU5aygnsHvRFMomEeWJ/Tangerine.webp',
  color: 'bg-orange-400',
  description: 'Bright, juicy tangerine with a perfect balance of sweet and tangy citrus notes',
  features: ['Zero Calories', 'Alkaline', 'Vegan', 'Vitamin Infused', 'Flavored Water']
}, {
  name: 'Cucumber Melon',
  hipsterName: 'Garden Oasis Refresher',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/9vaKHzXRcidVkx8AH4gz6w/Cucumber_Melon.webp',
  color: 'bg-green-300',
  description: 'Crisp cucumber and sweet honeydew melon combine for a spa-like hydration experience',
  features: ['Zero Calories', 'Alkaline', 'Vegan', 'Vitamin Infused', 'Flavored Water']
}, {
  name: 'Cherry Vanilla',
  hipsterName: 'Ruby Berry Infusion',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/4MqL492Hq59nS4cU3eEKCs/Diet_Cherry_Vanilla.webp',
  color: 'bg-red-500',
  description: 'Ripe cherries with delicate vanilla undertones create a sophisticated flavor profile',
  features: ['Organic Cane Sugar', 'Alkaline', 'Vitamin Infused', 'Soda']
}, {
  name: 'Diet Cola',
  hipsterName: 'Classic Refresher',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/kMRRwmpg9RYytQfuwDt6tX/Diet_Cola.webp',
  color: 'bg-amber-900',
  description: 'Classic cola flavor with zero calories for a guilt-free refreshment experience',
  features: ['Zero Calories', 'Alkaline', 'Vegan', 'Vitamin Infused', 'Soda']
}, {
  name: 'Diet Watermelon Strawberry',
  hipsterName: 'Summer Berry Splash',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/gUkZpfHV3VqAP68ntrtX4G/Diet_Strawberry_Watermelon.webp',
  color: 'bg-pink-400',
  description: 'Sweet watermelon and ripe strawberry combine for a perfect summer refreshment with zero calories',
  features: ['Zero Calories', 'Alkaline', 'Vegan', 'Vitamin Infused', 'Soda']
}, {
  name: 'Orange',
  hipsterName: 'Citrus Sunrise Splash',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/pLpaCSAriGW3CqjXG3rSHT/Orange.webp',
  color: 'bg-orange-400',
  description: 'Bright, sun-ripened orange with a perfect balance of sweetness and tangy citrus notes',
  features: ['Organic Cane Sugar', 'Alkaline', 'Vitamin Infused', 'Soda']
}, {
  name: 'Pink Lemonade',
  hipsterName: 'Blush Citrus Refresher',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/9u79QAHhCp2GFCD65H7wCP/pink_Lemonade.webp',
  color: 'bg-pink-300',
  description: 'Delicate blend of tart lemons and sweet berries for a perfectly balanced, refreshing experience',
  features: ['Organic Cane Sugar', 'Alkaline', 'Vitamin Infused', 'Soda']
}, {
  name: 'Ginger Ale',
  hipsterName: 'Classic Spiced Effervescence',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/nLk1TJegEuMoUbeQ6RHpZd/Ginger.webp',
  color: 'bg-amber-200',
  description: 'Classic ginger ale with a perfect balance of sweetness and spice for a refreshing, soothing experience',
  features: ['Organic Cane Sugar', 'Alkaline', 'Vitamin Infused', 'Soda']
}, {
  name: 'Ginger Beer',
  hipsterName: 'Spiced Botanical Brew',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/meQh1yV9QtRmA5U9ks4a3H/Ginger_Beer.webp',
  color: 'bg-amber-300',
  description: 'Bold, spicy ginger with a touch of sweetness and effervescence for a refreshing kick',
  features: ['Organic Cane Sugar', 'Alkaline', 'Vitamin Infused', 'Soda']
}, {
  name: 'Unsweetened Iced Tea',
  hipsterName: 'Pure Heritage Brew',
  image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/4p3MFAfWVTAMC75xzNK3wa/Iced_Tea.png',
  color: 'bg-amber-600',
  description: 'Pure, unsweetened classic iced tea with a robust flavor profile and refreshing clean finish',
  features: ['Zero Calories', 'Alkaline', 'Vegan', 'Tea']
}];
const getFeatureColor = (feature: string) => {
  switch (feature.toLowerCase()) {
    case 'zero calories':
      return 'bg-blue-100 text-blue-800 border border-blue-200';
    case 'alkaline':
      return 'bg-purple-100 text-purple-800 border border-purple-200';
    case 'vegan':
      return 'bg-green-100 text-green-800 border border-green-200';
    case 'vitamin infused':
      return 'bg-pink-100 text-pink-800 border border-pink-200';
    case 'flavored water':
      return 'bg-cyan-100 text-cyan-800 border border-cyan-200';
    case 'organic cane sugar':
      return 'bg-amber-100 text-amber-800 border border-amber-200';
    case 'organic':
      return 'bg-emerald-100 text-emerald-800 border border-emerald-200';
    case 'soda':
      return 'bg-red-100 text-red-800 border border-red-200';
    case 'coffee':
      return 'bg-amber-100 text-amber-800 border border-amber-200';
    case 'tea':
      return 'bg-amber-100 text-amber-800 border border-amber-200';
    case 'electrolytes':
      return 'bg-blue-100 text-blue-800 border border-blue-200';
    default:
      return 'bg-gray-100 text-gray-800 border border-gray-200';
  }
};
const FlavorCircles = () => {
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const scroll = (direction: 'left' | 'right') => {
    if (scrollContainerRef.current) {
      const scrollAmount = direction === 'left' ? -300 : 300;
      scrollContainerRef.current.scrollBy({
        left: scrollAmount,
        behavior: 'smooth'
      });
    }
  };
  return <section className="py-16 bg-gradient-to-b from-blue-50 via-white to-blue-50 relative overflow-hidden" data-id="element-195">
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10" data-id="element-196">
        <div className="absolute top-40 -left-20 w-80 h-80 bg-blue-200 rounded-full opacity-20 blur-3xl" data-id="element-197"></div>
        <div className="absolute bottom-20 right-20 w-96 h-96 bg-green-200 rounded-full opacity-20 blur-3xl" data-id="element-198"></div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-199">
        <div className="text-center mb-10" data-id="element-200">
          <div className="inline-block px-6 py-2 bg-blue-500 text-white text-sm font-medium rounded-full mb-4 animate-pulse" data-id="element-201">
            COMPLETE BEVERAGE SOLUTION
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-navy-950 mb-4" data-id="element-202">
            29+ Premium Beverage Options
          </h2>
          <p className="mt-2 text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed" data-id="element-203">
            <span className="block font-medium text-blue-600 text-2xl mb-2" data-id="element-204">
              One System, Endless Possibilities
            </span>
            Our advanced beverage platform delivers a complete drink solution
            with premium options across multiple categories:
          </p>
          {/* Beverage category badges */}
          <div className="flex flex-wrap justify-center gap-3 mt-4 mb-6" data-id="element-205">
            <div className="bg-red-100 border border-red-200 text-red-800 px-4 py-2 rounded-full font-medium flex items-center" data-id="element-206">
              <span className="mr-2" data-id="element-207">🥤</span> Premium Sodas & Diet Options
            </div>
            <div className="bg-blue-100 border border-blue-200 text-blue-800 px-4 py-2 rounded-full font-medium flex items-center" data-id="element-208">
              <span className="mr-2" data-id="element-209">💦</span> Flavored Sparkling Waters
            </div>
            <div className="bg-amber-100 border border-amber-200 text-amber-800 px-4 py-2 rounded-full font-medium flex items-center" data-id="element-210">
              <span className="mr-2" data-id="element-211">☕</span> Iced Tea & Cold Brew Coffee
            </div>
            <div className="bg-green-100 border border-green-200 text-green-800 px-4 py-2 rounded-full font-medium flex items-center" data-id="element-212">
              <span className="mr-2" data-id="element-213">🏃</span> Electrolyte Sport Drinks
            </div>
            <div className="bg-purple-100 border border-purple-200 text-purple-800 px-4 py-2 rounded-full font-medium flex items-center" data-id="element-214">
              <span className="mr-2" data-id="element-215">⚡</span> Functional Wellness Shots
            </div>
          </div>
        </div>
        <div className="relative" data-id="element-216">
          <button onClick={() => scroll('left')} className="absolute left-0 top-1/2 transform -translate-y-1/2 z-10 bg-white/80 rounded-full p-3 shadow-lg hover:bg-white focus:outline-none transition-all duration-300 hover:scale-110" aria-label="Scroll left" data-id="element-217">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-218">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" data-id="element-219" />
            </svg>
          </button>
          <div ref={scrollContainerRef} className="flex overflow-x-auto scrollbar-hide py-6 px-4 -mx-4 snap-x" style={{
          scrollbarWidth: 'none',
          msOverflowStyle: 'none'
        }} data-id="element-220">
            {flavorOptions.map(flavor => <div key={flavor.name} className="flex flex-col items-center flex-shrink-0 px-6 snap-start group" style={{
            width: '280px'
          }} data-id="element-221">
                <div className={`w-40 h-40 md:w-48 md:h-48 rounded-full overflow-hidden border-4 ${flavor.color} border-opacity-30 transition-all duration-500 shadow-lg group-hover:scale-105 group-hover:shadow-xl`} data-id="element-222">
                  <img src={flavor.image} alt={`${flavor.name} flavor`} className="w-full h-full object-cover" width="192" height="192" loading="lazy" decoding="async" data-id="element-223" />
                </div>
                <div className="mt-3 text-center" data-id="element-224">
                  <span className="block text-sm uppercase tracking-wider text-blue-600 font-medium" data-id="element-225">
                    {flavor.name}
                  </span>
                  <span className="block mt-1 font-bold text-lg text-navy-950" data-id="element-226">
                    {flavor.hipsterName}
                  </span>
                  <p className="mt-1 text-sm text-gray-600 max-w-[220px]" data-id="element-227">
                    {flavor.description}
                  </p>
                  <div className="flex flex-wrap justify-center mt-2" data-id="element-228">
                    {flavor.features.map((feature, index) => <FeatureLabel key={index} text={feature} color={getFeatureColor(feature)} data-id="element-229" />)}
                  </div>
                </div>
              </div>)}
          </div>
          <button onClick={() => scroll('right')} className="absolute right-0 top-1/2 transform -translate-y-1/2 z-10 bg-white/80 rounded-full p-3 shadow-lg hover:bg-white focus:outline-none transition-all duration-300 hover:scale-110" aria-label="Scroll right" data-id="element-230">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-231">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" data-id="element-232" />
            </svg>
          </button>
        </div>
        <style jsx data-id="element-233">{`
          .scrollbar-hide::-webkit-scrollbar {
            display: none;
          }
        `}</style>
        <div className="mt-10 text-center" data-id="element-234">
          <div className="inline-block px-6 py-3 bg-blue-100 text-blue-800 rounded-lg font-medium text-lg mb-4" data-id="element-235">
            All Your Beverage Needs in One System
          </div>
          <p className="text-gray-600 mb-2 max-w-3xl mx-auto" data-id="element-236">
            All of our flavor essences are crafted with premium clean label
            ingredients, ethically sourced botanicals, and zero artificial
            additives.
          </p>
          <div className="bg-amber-50 border border-amber-200 rounded-lg p-6 max-w-2xl mx-auto mt-6" data-id="element-237">
            <p className="text-amber-800 text-sm italic" data-id="element-238">
              <span className="font-semibold" data-id="element-239">⚠️ A Note on Garnishes:</span>{' '}
              Those artisanal fruit slices, locally-foraged herb sprigs, and
              hand-carved cocktail embellishments shown in our photography are
              not included with your SmartSoda system. Consider them inspiration
              for your own beverage artistry. We believe in you! 🍋🥝🍓
            </p>
          </div>
        </div>
      </div>
    </section>;
};
export default FlavorCircles;